import { render, staticRenderFns } from "./MemberTagVTextarea.vue?vue&type=template&id=843c771e&scoped=true"
import script from "./MemberTagVTextarea.vue?vue&type=script&lang=js"
export * from "./MemberTagVTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843c771e",
  null
  
)

export default component.exports